<template>
  <main-container>
    <main-header />

    <indicador-navegacao />

    <form-container>
      <form-input-grupo tituloGrupo="CNPJ">
        <form-input-individual>
          <label class="form-pergunta-titulo" for="cnpj">Selecione o CNPJ da empresa que será realizada a implantação *</label>
          <span class="form-pergunta-subtitulo">Informe o mesmo CNPJ que foi utilizado na contratação do Microvix.</span>
          <vue-select
            class="style-chooser"
            :id="'cnpj'"
            label="CNPJ"
            :options="cnpjOportunidade"
            v-model="cnpjSelecionado"
            :selectable="option => option.DisponivelParaImplantacao()"
            placeholder="Selecione um CNPJ"
          >
            <template #option="option">
              <div class="option-container" :class="{ 'cnpj-indisponivel': !option.DisponivelParaImplantacao() }">
                {{ formataCnpj(option.CNPJ) + descricaoPlanoComercial(option.PlanoComercial) }}
                <small v-if="option.Implantado" class="ml-2">Este CNPJ já foi implantado no Microvix</small>
                <small v-else-if="!option.PlanoComercial" class="ml-2">Plano comercial não identificado para este CNPJ</small>
              </div>
            </template>
            <template #selected-option="option">
              {{ formataCnpj(option.CNPJ) + descricaoPlanoComercial(option.PlanoComercial) }}
            </template>
            <div slot="no-options">Sem opções disponíveis!</div>
          </vue-select>
        </form-input-individual>
      </form-input-grupo>
      <form-buttons
        @voltar-form-anterior="voltarPaginaLogin"
        @avancar-proximo-form="avancarProximoForm(objetoValidacao, montaObjetoCommit, 'commit', 'setDataEmpresaPT2', '/dados/empresa')"
        voltar="Sair"
      />
    </form-container>
  </main-container>
</template>

<script>
import swal from '../../utils/alerts';

export default {
  data() {
    return {
      cnpjOportunidade: [],
      cnpjAtivos: [],
      cnpjSelecionado: '',
    };
  },
  created() {
    this.inicializaDados();
  },
  watch: {},
  computed: {
    objetoValidacao() {
      const dados = [];
      dados.push(this.montaObjetoValidacao(['campoObrigatorio', 'validaCnpj'], this.cnpjSelecionado.CNPJ, 'cnpj'));
      return dados;
    },
    montaObjetoCommit() {
      return {
        cnpj: this.cnpjSelecionado.CNPJ,
      };
    },
  },
  methods: {
    inicializaDados() {
      this.inicializaDadosCnpj();
    },
    inicializaDadosCnpj() {
      this.cnpjAtivos = this.$store.state.dadosFormulario.cnpjAtivos;

      this.cnpjOportunidade = this.$store.state.dynamicsCNPJs.map(cnpj => ({
        CNPJ: cnpj,
        Implantado: this.cnpjAtivos.includes(cnpj),
        PlanoComercial: this.$store.state.dynamicsEmpresas.find(empresa => empresa.CNPJ == cnpj)?.PlanoComercial,
        DisponivelParaImplantacao() {
          return !!this.PlanoComercial && !this.Implantado;
        },
      }));

      this.cnpjSelecionado = this.cnpjOportunidade.find(cnpj => cnpj.DisponivelParaImplantacao());

      if (!this.cnpjSelecionado) swal.exibirMensagemAlerta('Não existem CNPJs disponíveis para implantação nessa oportunidade.');
    },
    voltarPaginaLogin() {
      swal.exibirPergunta('Sair', 'Deseja sair da rotina Easy Implantação?', result => {
        if (result) {
          this.$store.commit('resetAllStates');
          this.$router.push('/');
        }
      });
    },
    formataCnpj(cnpj) {
      return cnpj.replace(/\D/g, '').replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
    },
    descricaoPlanoComercial(planoComercial) {
      return planoComercial ? ` - ${planoComercial.Descricao}` : '';
    },
  },
};
</script>

<style>
.option-container {
  display: flex;
  align-items: center;
}

.cnpj-indisponivel {
  color: red;
}
</style>
